import React from "react";
import { Box } from "@mui/material";
import { Heading } from "../../Components/Heading";
import { SearchBox } from "../../Components/SearchBox";
import { styled } from "@mui/material/styles";
import { Container } from "@mui/system";
import { useCustomerTags } from "../../hooks/useCustomerTags";

const KbFilters = styled("div")(({ theme }) => ({
  flexGrow: 1,
  paddingBlockStart: "3rem",
  "& .search-box": {
    maxWidth: "48.25rem",
    margin: "0 auto",
    "& .heading": {
      marginBottom: "1.875rem",
    },
  },
}));

const Landing = () => {
  const {
    techTags,
    businessTags,
    techTagsLoading,
    businessTagsLoading,
    techTagsError,
    businessTagsError,
  } = useCustomerTags();

  return (
    <KbFilters>
      <Container>
        <Box className="search-box">
          <Heading variant="h1" align="center" title="Hello, how may I help you ?" className="heading" />
          <SearchBox
            id="search"
            labelText="Search"
            onlySearchIcon={false}
            isTechTagsLoading={techTagsLoading}
            isBusinessTagsLoading={businessTagsLoading}
            techTagsError={techTagsError}
            businessTagsError={businessTagsError}
            techTags={techTags}
            businessTags={businessTags}
          />
        </Box>
      </Container>
    </KbFilters>
  );
};

export default Landing;
